import { makeObservable, override } from 'mobx';
import { FormStore, GlobalStore } from '@roc/feature-app-core';

const form = {
  fields: {
    lienType: {
      value: '',
      error: null,
      rule: 'required',
      label: 'Lien Type',
    },
    madeBy: {
      value: '',
      error: null,
      rule: 'required',
      label: 'Made by',
    },
    madeTo: {
      value: '',
      error: null,
      rule: 'required',
      label: 'To',
    },
    datedDate: {
      value: '',
      error: null,
      rule: 'required',
      label: 'Dated',
    },
    recordedDate: {
      value: '',
      error: null,
      rule: 'required',
      label: 'Recorded',
    },
    originalAmount: {
      value: '',
      error: null,
      rule: 'required',
      label: 'Amount',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export const LIEN_TYPE_OPTIONS = [
  { label: 'Please Select', value: '' },
  { label: 'Deed of Trust', value: 'Deed of Trust' },
  { label: 'Mortgage', value: 'Mortgage' },
  { label: 'UCC', value: 'UCC' },
  { label: 'Judgment', value: 'Judgment' },
  { label: 'Assessment Lien', value: 'Assessment Lien' },
  { label: 'Tax Lien', value: 'Tax Lien' },
  { label: "Mechanic's Lien", value: "Mechanic's Lien" },
];

export class LienFormStore extends FormStore {
  constructor(globalStore: GlobalStore) {
    super(form, globalStore);
  }
}
